import { easeSnappy, durMedium } from './easings.js';
import { prefersReducedMotion } from './prefersReducedMotion.js';

/** scale + opacity entrance on page load (no scroll gating). */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;
    window.gsap.from(this.$el, {
      scale: 0.96,
      // autoAlpha (opacity + visibility) so contrast checkers skip the
      // hidden element rather than flagging low-contrast text at opacity 0.
      autoAlpha: 0,
      duration: durMedium,
      ease: easeSnappy,
    });
  },
});
